<div class="container mt-4 border border-radius-5 p-3 w-50">
    <h2>Logga in som användare</h2>

<form (ngSubmit)="impersonate()">
    <div class="d-flex justify-content-start align-items-center">
        
      <label class="form-control-label mr-2" for="userName">
        Medlems-ID:
          <input class="form-control form-control-sm" style="width:90px;"
          type="text"
          [(ngModel)]="userName"
          name="userName"
          required>
      </label>
      
       <button class="btn btn-sm p-0 ms-3 mt-3" type="submit">
      Logga in som användare
    </button>
    </div>

   
</form>
</div>
